/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * All of the possible `DxpScreenLayout*`'s.
 */
export type DxpScreenLayout = DxpScreenLayoutStandard | DxpScreenLayoutBox | DxpScreenLayoutWide;

/**
 * The DxpScreen standard layout type.
 * @export
 */
export type DxpScreenLayoutStandard = typeof DXP_SCREEN_LAYOUT_STANDARD;

/**
 * The DxpScreen box layout type.
 * @export
 */
export type DxpScreenLayoutBox = typeof DXP_SCREEN_LAYOUT_BOX;

/**
 * The DxpScreen wide layout type.
 * @export
 */
export type DxpScreenLayoutWide = typeof DXP_SCREEN_LAYOUT_WIDE;

/**
 * The DxpScreen standard layout constant.
 * @export
 */
export const DXP_SCREEN_LAYOUT_STANDARD = `standard`;

/**
 * The DxpScreen box layout constant.
 * @export
 */
export const DXP_SCREEN_LAYOUT_BOX = `box`;

/**
 * The DxpScreen wide layout constant.
 * @export
 */
export const DXP_SCREEN_LAYOUT_WIDE = `wide`;
